import classNames from 'classnames'
import React from 'react'
import Select from '../select'
import { Dropdown, DropdownItemType } from '../dropdown'
import { OptionType } from '../atoms/select/select'
import { MobileLayoutType } from './tabordion'
import type { Props } from './tabordion'

type TabordionDropDownProps = {
  mobileLayout: Props['mobileLayout']
  items: Props['items']
  selectClassName: Props['selectClassName']
  toggleItem: (tab: number) => void
  activeTabs: number[]
  links: Props['links']
  dropdownClassName: Props['dropdownClassName']
  selectItemClassName: Props['selectItemClassName']
}
export default function TabordionDropDown({
  mobileLayout,
  items,
  toggleItem,
  activeTabs,
  links,
  dropdownClassName,
  selectClassName,
  selectItemClassName,
}: TabordionDropDownProps) {
  //? Memo?
  const selectOptions: OptionType[] = items.map(item => {
    return {
      value: item.selectValue ?? item.selectTitle ?? '',
      text: item.selectTitle ?? '',
    }
  })

  //? Memo?
  const dropdownOptions: DropdownItemType[] = items.map(item => {
    return {
      title: item.title,
      href: item.href ?? '',
    }
  })

  return (
    <>
      {mobileLayout === MobileLayoutType.SELECT && (
        <Select
          className={selectClassName}
          onChange={x => toggleItem(selectOptions.findIndex(option => option.value === x))}
          value={selectOptions[activeTabs[0]].value}
          options={selectOptions}
        />
      )}

      {mobileLayout === MobileLayoutType.DROPDOWN && (
        <Dropdown
          big={true}
          activeItem={dropdownOptions[activeTabs[0]].title ?? ''}
          onItemClick={x =>
            !links ? toggleItem(dropdownOptions.findIndex(option => option.title === x)) : null
          }
          items={dropdownOptions}
          links={links}
          className={dropdownClassName}
        />
      )}

      {items.map((item, i) => (
        <div
          key={i}
          className={classNames(selectItemClassName, {
            'd-none': !activeTabs.includes(i),
          })}>
          {item.content ? item.content : item.noContentText}
        </div>
      ))}
    </>
  )
}
